import * as Headless from '@headlessui/react'
import NextLink from 'next/link'
import { forwardRef, ReactNode } from 'react'

interface LinkProps extends React.ComponentPropsWithoutRef<typeof NextLink> {
  children: ReactNode
}

export const Link = forwardRef<HTMLAnchorElement, LinkProps>(function Link(
  props,
  ref
) {
  return (
    <Headless.DataInteractive>
      <NextLink ref={ref} {...props} />
    </Headless.DataInteractive>
  )
})

